import { FilterFooter, FilterSection } from '@hakimo-ui/hakimo/ui-filters';
import { Select } from '@hakimo-ui/hakimo/ui-elements';
import { InputField, Toggle } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { defaultFilters, TenantsFilters } from '../../types';
import { PRODUCT_TYPE_OPTIONS } from '../util';

interface Props {
  filters: TenantsFilters;
  onApplyFilters: (filters: TenantsFilters) => void;
}

function FilterPanelContent(props: Props) {
  const { filters, onApplyFilters } = props;
  const [localFilters, setLocalFilters] = useState<TenantsFilters>(filters);

  return (
    <div className="flex h-full flex-col space-y-6">
      <div className="dark:divide-dark-border-bg dark:border-dark-border-bg divide-y border-b border-t">
        <FilterSection
          title="Location City"
          content={
            <InputField
              label=""
              type="text"
              value={localFilters.locationCity}
              onChange={(e) =>
                setLocalFilters({
                  ...localFilters,
                  locationCity: e.target.value,
                })
              }
              placeholder="Enter city..."
            />
          }
          hasFilterApplied={localFilters.locationCity.length > 0}
        />
        <FilterSection
          title="Location State"
          content={
            <InputField
              label=""
              type="text"
              value={localFilters.locationState}
              onChange={(e) =>
                setLocalFilters({
                  ...localFilters,
                  locationState: e.target.value,
                })
              }
              placeholder="Enter state..."
            />
          }
          hasFilterApplied={localFilters.locationState.length > 0}
        />
        <FilterSection
          title="Location Country"
          content={
            <InputField
              label=""
              type="text"
              value={localFilters.locationCountry}
              onChange={(e) =>
                setLocalFilters({
                  ...localFilters,
                  locationCountry: e.target.value,
                })
              }
              placeholder="Enter country..."
            />
          }
          hasFilterApplied={localFilters.locationCountry.length > 0}
        />
        <FilterSection
          title="Show Inactive Tenants"
          content={
            <div className="py-2">
              <Toggle
                enabled={localFilters.showInactiveTenants}
                onChange={(enabled) =>
                  setLocalFilters({
                    ...localFilters,
                    showInactiveTenants: enabled,
                  })
                }
                label="Include inactive tenants"
                type="positive"
              />
            </div>
          }
          hasFilterApplied={localFilters.showInactiveTenants}
        />
        <FilterSection
          title="Product Type"
          content={
            <Select
              label=""
              value={
                PRODUCT_TYPE_OPTIONS.find(
                  (opt) => opt.id === localFilters.productType
                ) || null
              }
              getItems={(query: string) =>
                PRODUCT_TYPE_OPTIONS.filter((option) =>
                  option.label.toLowerCase().includes(query.toLowerCase())
                )
              }
              displayValue={(item) => item?.label ?? ''}
              onChange={(option) =>
                setLocalFilters({
                  ...localFilters,
                  productType: option?.id ?? '',
                })
              }
              placeholder="Select product type..."
            />
          }
          hasFilterApplied={localFilters.productType.length > 0}
        />
      </div>
      <div className="w-full grow"></div>
      <div className="flex-shrink-0">
        <FilterFooter
          onApply={() => onApplyFilters(localFilters)}
          onReset={() => setLocalFilters(defaultFilters)}
          trackingEventNameApply="apply_tenants_filters"
          trackingEventNameReset="reset_tenants_filters"
        />
      </div>
    </div>
  );
}

export default FilterPanelContent;
